import { render, staticRenderFns } from "./Presupuesto.vue?vue&type=template&id=60a0a45b&"
import script from "./Presupuesto.vue?vue&type=script&lang=js&"
export * from "./Presupuesto.vue?vue&type=script&lang=js&"
import style0 from "./Presupuesto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports